﻿﻿﻿<otherasset-filter (outputFilter)="getFilteredOtherAssetsByTenant()"></otherasset-filter>
<otherasset-list [list]="list" [showLocalFilter]="showLocalFilter"></otherasset-list>